import React, { useState } from "react";
import { Box, Tabs, Tab, Container, Paper, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarPlus,
  faUser,
  faUserCircle,
} from "@fortawesome/free-regular-svg-icons";

import ClientManagement from "./ClientManagement";
import CreateClientVisit from "./CreateClientVisit";
import AssignEmployee from "./AssignEmployee";

const CreateClientScreen = ({
  initialActiveKey,
  initialClient,
  initialVisit,
}) => {
  const [activeKey, setActiveKey] = useState(initialActiveKey || "create-client");
  const [clientId, setClientId] = useState(initialClient || null);
  const [visitId, setVisitId] = useState(initialVisit || null);

  const handleTabChange = (event, newValue) => {
    setActiveKey(newValue);
  };

  return (
    <Container maxWidth={false} sx={{ mt: 0, width: "100%", px: { xs: 1, sm: 2, md: 3 } }}>
      <Paper
        elevation={0}
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          mb: 3,
          bgcolor: 'transparent',
        }}
      >
        <Tabs
          value={activeKey}
          onChange={handleTabChange}
          centered
          textColor="primary"
          indicatorColor="primary"
          aria-label="client creation steps"
          sx={{
            '& .MuiTabs-indicator': {
              height: 3,
              borderRadius: '3px 3px 0 0',
            },
            '& .MuiTab-root': {
              minHeight: 48,
              px: 3,
              py: 1,
              '&.Mui-selected': {
                color: '#2469F0',
              },
            },
          }}
        >
          {!initialClient && (
            <Tab
              value="create-client"
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <FontAwesomeIcon
                    icon={faUser}
                    style={{
                      color: activeKey === 'create-client' ? '#2469F0' : '#94A3B8',
                      fontSize: '18px',
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: '0.85rem',
                      fontWeight: 500,
                      color: activeKey === 'create-client' ? '#2469F0' : '#64748B',
                    }}
                  >
                    Create Client
                  </Typography>
                </Box>
              }
            />
          )}
          <Tab
            value="create-visit"
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <FontAwesomeIcon
                  icon={faCalendarPlus}
                  style={{
                    color: activeKey === 'create-visit' ? '#2469F0' : '#94A3B8',
                    fontSize: '18px',
                  }}
                />
                <Typography
                  sx={{
                    fontSize: '0.85rem',
                    fontWeight: 500,
                    color: activeKey === 'create-visit' ? '#2469F0' : '#64748B',
                  }}
                >
                  Create Visit
                </Typography>
              </Box>
            }
          />
          <Tab
            value="assign-employee"
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <FontAwesomeIcon
                  icon={faUserCircle}
                  style={{
                    color: activeKey === 'assign-employee' ? '#2469F0' : '#94A3B8',
                    fontSize: '18px',
                  }}
                />
                <Typography
                  sx={{
                    fontSize: '0.85rem',
                    fontWeight: 500,
                    color: activeKey === 'assign-employee' ? '#2469F0' : '#64748B',
                  }}
                >
                  Assign Employee
                </Typography>
              </Box>
            }
          />
        </Tabs>
      </Paper>

      {/* Tab Panels */}
      <Box sx={{ py: 0, width: "100%" }}>
        {activeKey === "create-client" && (
          <ClientManagement
            setActiveKey={setActiveKey}
            setClientId={setClientId}
          />
        )}

        {activeKey === "create-visit" && (
          <Box sx={{ width: "100%" }}>
            {clientId ? (
              <CreateClientVisit
                clientID={clientId}
                setActiveKey={setActiveKey}
                setVisitId={setVisitId}
              />
            ) : (
              <Box
                sx={{
                  textAlign: 'center',
                  color: 'text.secondary',
                  mt: 4,
                  p: 4,
                  bgcolor: '#F8FAFC',
                  borderRadius: 2,
                  border: '1px dashed #E2E8F0',
                }}
              >
                <Typography variant="body1" fontWeight={500}>
                  Please create or select a client first.
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Go back to "Create Client" tab to get started.
                </Typography>
              </Box>
            )}
          </Box>
        )}

        {activeKey === "assign-employee" && (
          <Box sx={{ width: "100%" }}>
            {visitId ? (
              <AssignEmployee visitId={visitId} clientId={clientId} />
            ) : (
              <Box
                sx={{
                  textAlign: 'center',
                  color: 'text.secondary',
                  mt: 4,
                  p: 4,
                  bgcolor: '#F8FAFC',
                  borderRadius: 2,
                  border: '1px dashed #E2E8F0',
                }}
              >
                <Typography variant="body1" fontWeight={500}>
                  Please create a visit before assigning an employee.
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Go back to "Create Visit" tab to get started.
                </Typography>
              </Box>
            )}
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default CreateClientScreen;